var $3d55d1f97c377e83$exports = {};
$3d55d1f97c377e83$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " se\xE7ilmedi.");
  },
  "longPressToSelect": "Se\xE7im moduna girmek i\xE7in uzun bas\u0131n.",
  "select": "Se\xE7",
  "selectedAll": "T\xFCm \xF6geler se\xE7ildi.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Hi\xE7bir \xF6ge se\xE7ilmedi",
      one: function one() {
        return "".concat(formatter.number(args.count), " \xF6ge se\xE7ildi");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \xF6ge se\xE7ildi");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " se\xE7ildi.");
  }
};
export { $3d55d1f97c377e83$exports as default };